import { Controller } from '@hotwired/stimulus'

// Matches the .flash-message--leaving fade in application/_flash.html.erb
const FADE_OUT_MS = 300

export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } }

  connect() {
    this.startDismissTimer()
  }

  disconnect() {
    this.clearTimers()
  }

  // Hovering holds the message on screen so long errors stay readable.
  pause() {
    this.clearTimers()
  }

  // Hovering mid-fade brings the message back rather than leaving it half-faded.
  resume() {
    this.element.classList.remove('flash-message--leaving')
    this.startDismissTimer()
  }

  startDismissTimer() {
    this.clearTimers()
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  clearTimers() {
    if (this.timeout) clearTimeout(this.timeout)
    if (this.fadeTimeout) clearTimeout(this.fadeTimeout)
    this.timeout = null
    this.fadeTimeout = null
  }

  dismiss() {
    this.element.classList.add('flash-message--leaving')
    this.fadeTimeout = setTimeout(() => this.remove(), FADE_OUT_MS)
  }

  remove() {
    this.element.remove()
  }
}
